import { render, staticRenderFns } from "./Lgx266206729396551680.vue?vue&type=template&id=e472a1d4&"
import script from "./Lgx266206729396551680.vue?vue&type=script&lang=js&"
export * from "./Lgx266206729396551680.vue?vue&type=script&lang=js&"
import style0 from "./Lgx266206729396551680.vue?vue&type=style&index=0&id=e472a1d4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports